import { useRef } from 'react';

const CODE_LENGTH = 6;

export default function CodeInput({ value, onChange, onComplete, error, disabled }) {
  const refs = useRef([]);

  const setDigit = (index, char) => {
    const digit = char.replace(/\D/g, '').slice(-1);
    const chars = value.split('');
    while (chars.length < CODE_LENGTH) chars.push('');
    chars[index] = digit;
    const next = chars.join('').slice(0, CODE_LENGTH).replace(/\s/g, '');
    onChange(next);
    if (digit && index < CODE_LENGTH - 1) {
      refs.current[index + 1]?.focus();
    }
    if (digit && next.length === CODE_LENGTH) {
      onComplete?.(next);
    }
  };

  const onKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      if (!value[index] && index > 0) {
        refs.current[index - 1]?.focus();
      } else {
        const chars = value.split('');
        chars[index] = '';
        onChange(chars.join('').trim());
      }
    }
    if (e.key === 'ArrowLeft' && index > 0) refs.current[index - 1]?.focus();
    if (e.key === 'ArrowRight' && index < CODE_LENGTH - 1) refs.current[index + 1]?.focus();
  };

  const onPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, CODE_LENGTH);
    onChange(pasted);
    const focusIndex = Math.min(pasted.length, CODE_LENGTH - 1);
    refs.current[focusIndex]?.focus();
    if (pasted.length === CODE_LENGTH) {
      onComplete?.(pasted);
    }
  };

  return (
    <div className={`auth-code-input${error ? ' auth-code-input--error' : ''}`}>
      <label className="auth-code-input__label">
        <div className="auth-code-input__borders" data-code-input-type="borders">
          {Array.from({ length: CODE_LENGTH }, (_, index) => (
            <input
              key={index}
              ref={(el) => { refs.current[index] = el; }}
              type="text"
              inputMode="numeric"
              autoComplete={index === 0 ? 'one-time-code' : 'off'}
              className="auth-code-input__cell"
              value={value[index] || ''}
              onChange={(e) => setDigit(index, e.target.value)}
              onKeyDown={(e) => onKeyDown(index, e)}
              onPaste={onPaste}
              onFocus={(e) => e.target.select()}
              disabled={disabled}
              maxLength={1}
              aria-label={`Digit ${index + 1}`}
            />
          ))}
        </div>
      </label>
    </div>
  );
}
